import { useEffect, useState } from "react";

const LOGO_URL =
  "https://static.readdy.ai/image/e50d925263add9c47b947a5709171c8c/68c96a7205abbabbb730277e1bc039a2.png";

export default function LoadingScreen() {
  const [fadeOut, setFadeOut] = useState(false);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const t1 = setTimeout(() => setFadeOut(true), 1200);
    const t2 = setTimeout(() => setVisible(false), 1600);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white"
      style={{
        opacity: fadeOut ? 0 : 1,
        transition: "opacity 0.4s ease",
        pointerEvents: fadeOut ? "none" : "all",
      }}
    >
      {/* Logo — letrero, sin fondo, sin recortes */}
      <img
        src={LOGO_URL}
        alt="Imagen Printing"
        className="w-72 max-w-[80vw] h-auto object-contain"
      />

      {/* Spinner dorado debajo del logo */}
      <div className="relative w-12 h-12 mt-8">
        <svg
          className="absolute inset-0 w-full h-full"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ animation: "ipSpin 1s linear infinite" }}
        >
          <circle cx="24" cy="24" r="20" stroke="#e5e5e5" strokeWidth="4" />
          <circle
            cx="24"
            cy="24"
            r="20"
            stroke="url(#goldGrad)"
            strokeWidth="4"
            strokeLinecap="round"
            strokeDasharray="45 80"
            strokeDashoffset="0"
          />
          <defs>
            <linearGradient id="goldGrad" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
              <stop offset="0%" stopColor="#C9A84C" />
              <stop offset="50%" stopColor="#F5D07A" />
              <stop offset="100%" stopColor="#A0722A" />
            </linearGradient>
          </defs>
        </svg>
      </div>

      {/* Texto de carga debajo del logo */}
      <p
        className="mt-5 text-lg font-semibold tracking-[0.2em] uppercase"
        style={{
          color: "#C9A84C",
          textShadow: "0 0 12px rgba(201,168,76,0.25)",
          animation: "textPulse 1.6s ease-in-out infinite",
        }}
      >
        Imagen Printing
      </p>
      <p className="mt-1.5 text-xs text-gray-400 tracking-wider">
        Loading...
      </p>

      <style>{`
        @keyframes ipSpin {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
        @keyframes textPulse {
          0%, 100% { opacity: 0.6; }
          50%       { opacity: 1; }
        }
      `}</style>
    </div>
  );
}